import { makeSimpleExperiment } from '../../common/ExperimentContext/types';

export const DefaultTextSearchExperiment = makeSimpleExperiment('default-text-search');
